const initialState = {
  RoleDetails: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SINGLE_ROLE_DETAILS':
      return {
        ...state,
        RoleDetails: action.data,
      }
    default:
      return state
  }
}
